import React from 'react';
import { Link } from 'react-router-dom';
import Username from './../common/Username';
import Avatar from './../common/Avatar';

const ActivityFeedDemotion = (props) => (
    <li className="media">
        <div className="row">
            <div className="col-xs-2">
                <Avatar image={props.users[props.item.user].avatar} rank={props.ranks[props.users[props.item.user].rank]} width="32" height="32" />
            </div>
            <div className="col-xs-10">
                <Username user={props.users[props.item.user]} rank={props.ranks[props.users[props.item.user].rank]} placement="left" />
                <span className="activity-date text-muted"> was demoted to </span>
                <Link to="/about/ranks">{props.ranks[props.item.rank].title}</Link>
            </div>
        </div>
    </li>
);

export default ActivityFeedDemotion;


// WEBPACK FOOTER //
// ./src/ActivityFeed/ActivityFeedDemotion.js